import { Tag } from "lucide-react";
import { Price, CurrencySelect, usd } from "@/lib/currency";
import { TermsCheckbox } from "@/components/site/TermsCheckbox";
import { BillingFields } from "@/components/site/BillingFields";

export const TIERS = "3–4 items 10% off · 5–9 items 15% · 10+ items 20%";

function Discount({ q }) {
  if (q.discount_usd > 0)
    return (
      <div className="flex justify-between text-xs text-[#03AB9E] mt-2" data-testid="order-discount">
        <span className="flex items-center gap-1"><Tag className="h-3 w-3" />{q.discount_type === "bundle" ? `Bundle discount (${q.discount_pct}%)` : `Renewal discount ${q.coupon} (${q.discount_pct}%)`}</span>
        <span className="font-mono">−{usd(q.discount_usd)}</span>
      </div>
    );
  return null;
}

export function OrderSummary({ quote: q, user, billing, setBilling, agree, setAgree, country, onPay, payLabel, extra, empty = "Select one or more products to see the price." }) {
  return (
    <aside className="bg-slate-950/60 border border-slate-800 rounded-lg p-4" data-testid="order-summary">
      {!q && <p className="text-xs text-slate-500">{empty}</p>}
      {q && (
        <>
          <div className="space-y-1.5 max-h-48 overflow-y-auto">{q.items.map((i) => (
            <div key={`${i.module || "r"}-${i.product}`} className="flex justify-between gap-3 text-xs">
              <span className="text-slate-300 truncate">{i.product}<span className="text-slate-500"> · {i.owned ? "already owned" : i.kind === "report" ? "Report" : `${i.label}${i.regions?.length ? ` · ${i.regions.join(", ")}` : ""}`}</span></span>
              <span className="font-mono shrink-0">{usd(i.price_usd)}</span>
            </div>
          ))}</div>
          {q.discount_usd > 0 && <div className="flex justify-between text-xs text-slate-400 border-t border-slate-800 mt-3 pt-2"><span>Subtotal</span><span className="font-mono">{usd(q.subtotal_usd)}</span></div>}
          <Discount q={q} />
          {q.next_tier && q.count > 0 && <p className="text-[11px] text-[#F58B23] mt-2" data-testid="order-next-tier">Add {q.next_tier.count - q.count} more item{q.next_tier.count - q.count > 1 ? "s" : ""} to get {q.next_tier.pct}% off</p>}
          {q.errors?.map((e) => <p key={e} className="text-xs text-red-400 mt-1">{e}</p>)}
        </>
      )}
      <div className="border-t border-slate-800 mt-3 pt-3 flex justify-between items-end">
        <span className="text-xs text-slate-400">12 months access</span>
        <span data-testid="order-total">{q ? <Price value={q.total_usd} big /> : "—"}</span>
      </div>
      <CurrencySelect />
      {user && <BillingFields value={billing} onChange={setBilling} country={country} />}
      {user && <TermsCheckbox checked={agree} onChange={setAgree} />}
      <button onClick={onPay} disabled={!q || q.total_usd <= 0 || (!!user && !agree)} data-testid="order-pay-button"
        className="mt-4 w-full h-10 rounded-md bg-[#F58B23] hover:bg-[#D97618] text-slate-950 font-semibold text-sm disabled:opacity-50 disabled:cursor-not-allowed">{payLabel}</button>
      {extra}
      <p className="text-[10px] text-slate-500 mt-3">{TIERS}</p>
    </aside>
  );
}
